import DataCards from '../../api/data_cards';
const dataCards = new DataCards();

const dataCardsModule = {
    namespaced: true,
    state: {
        loading: false,
        dataCards: [],
        totalDataCards: 0,
        groupMembers: [],
        subTopicsCards: [],
        totalGroupMembers: 0,
        totalSubTopicsCards: 0,
        groupName: null,
    },
    getters: {
        dataCards: (state) => state.dataCards,
        totalDataCards: (state) => state.totalDataCards,
        groupMembers: (state) => state.groupMembers,
        subTopicsCards: (state) => state.subTopicsCards,
        loading: (state) => state.loading,
        totalGroupMembers: (state) => state.totalGroupMembers,
        totalSubTopicsCards: (state) => state.totalSubTopicsCards,
        groupName: (state) => state.groupName,
    },
    mutations: {
        SET_LOADING: (state, loading) => {
            state.loading = loading;
        },
        SET_DATA_CARDS: (state, data) => {
            state.dataCards = data;
        },
        SET_TOTAL_DATA_CARDS: (state, count) => {
            state.totalDataCards = count;
        },
        SET_GROUP_MEMBERS: (state, data) => {
            state.groupMembers = data;
        },
        SET_TOTAL_GROUP_MEMBERS: (state, totalGroupMembers) => {
            state.totalGroupMembers = totalGroupMembers;
        },
        SET_SUB_TOPICS_CARDS: (state, data) => {
            state.subTopicsCards = data;
        },
        SET_TOTAL_SUB_TOPICS_CARDS: (state, count) => {
            state.totalSubTopicsCards = count;
        },
        SET_GROUP_NAME: (state, groupName) => {
            state.groupName = groupName;
        },
    },
    actions: {
        GetDataCards({ commit, state }, payload) {
            const query = (payload && payload.query) || {};
            return new Promise((resolve, reject) => {
                commit('SET_LOADING', true);
                dataCards.list(query).then(response => {
                    if (response) {
                        const items = response.groupCards || [];
                        let incomingCount = response.total || response.count || 0;
                        const offset = query.offset || 0;

                        // Heuristic to prevent incorrect total from API triggering pagination reset
                        if (offset > 0 && items.length > 0 && incomingCount < (offset + items.length)) {
                            incomingCount = state.totalDataCards;
                        }
                        commit('SET_DATA_CARDS', items);
                        commit('SET_TOTAL_DATA_CARDS', incomingCount);
                    }

                    commit('SET_LOADING', false);
                    resolve(response);
                }).catch(error => {
                    commit('SET_LOADING', false);
                    reject(error);
                });
            });
        },
        GetGroupMembers({ commit }, payload) {
            return new Promise((resolve, reject) => {
                commit('SET_LOADING', true);
                dataCards.usersGroupCards(payload.id, payload.query).then(response => {
                    if (response) {
                        commit('SET_GROUP_MEMBERS', (response && response.usersGroupCards) || []);
                        commit('SET_GROUP_NAME', (response && response.group_name) || []);
                        commit('SET_TOTAL_GROUP_MEMBERS', (response && response.total) || 0);
                        // commit('SET_SUB_TOPICS_CARDS', (response.groupCard && response.groupCard.subTopicsCards) || []);
                    }
                    commit('SET_LOADING', false);
                    resolve(response);
                }).catch(error => {
                    commit('SET_LOADING', false);
                    reject(error);
                });
            });
        },
        GetSubTopicsCards({ commit }, payload) {
            return new Promise((resolve, reject) => {
                commit('SET_LOADING', true);
                dataCards.subTopicsCards(payload.id, payload.query).then(response => {
                    commit('SET_SUB_TOPICS_CARDS', (response && response.subTopicsGroupCards) || []);
                    commit('SET_TOTAL_SUB_TOPICS_CARDS', (response && response.total) || 0);
                    commit('SET_LOADING', false);
                    resolve(response);
                }).catch(error => {
                    commit('SET_LOADING', false);
                    reject(error);
                });
            });
        },
        UpdateGroup({ commit }, payload) {
            return new Promise((resolve, reject) => {
                commit('SET_LOADING', true);
                dataCards.update(payload.id, payload.data).then(response => {
                    commit('SET_LOADING', false);
                    resolve(response);
                }).catch(error => {
                    commit('SET_LOADING', false);
                    reject(error);
                });
            });
        },
        AddGroupMembers({ commit }, payload) {
            return new Promise((resolve, reject) => {
                commit('SET_LOADING', true);
                dataCards.addUsers(payload.id, payload.userIds).then(response => {
                    commit('SET_LOADING', false);
                    resolve(response);
                }).catch(error => {
                    commit('SET_LOADING', false);
                    reject(error);
                });
            });
        },
        RemoveGroupMember({ commit }, payload) {
            return new Promise((resolve, reject) => {
                commit('SET_LOADING', true);
                dataCards.removeMember(payload.id, payload.userId).then(response => {
                    commit('SET_LOADING', false);
                    resolve(response);
                }).catch(error => {
                    commit('SET_LOADING', false);
                    reject(error);
                });
            });
        },
        CreateDataCard({ commit }, payload) {
            return new Promise((resolve, reject) => {
                commit('SET_LOADING', true);
                dataCards.store(payload).then(response => {
                    commit('SET_LOADING', false);
                    resolve(response);
                }).catch(error => {
                    commit('SET_LOADING', false);
                    reject(error);
                });
            });
        },
        DeleteDataCard({ commit }, id) {
            return new Promise((resolve, reject) => {
                commit('SET_LOADING', true);
                dataCards.delete(id).then(response => {
                    commit('SET_LOADING', false);
                    resolve(response);
                }).catch(error => {
                    commit('SET_LOADING', false);
                    reject(error);
                });
            });
        },
        UnAssignMe({ commit }, groupId) {
            return new Promise((resolve, reject) => {
                commit('SET_LOADING', true);
                dataCards.unAssignMe(groupId).then(response => {
                    commit('SET_LOADING', false);
                    resolve(response);
                }).catch(error => {
                    commit('SET_LOADING', false);
                    reject(error);
                });
            });
        },
        SubmitStudentAnswers({ commit }, payload) {
            return new Promise((resolve, reject) => {
                commit('SET_LOADING', true);
                dataCards.submitAnswers(payload).then(response => {
                    commit('SET_LOADING', false);
                    resolve(response);
                }).catch(error => {
                    commit('SET_LOADING', false);
                    reject(error);
                });
            });
        },
        UpdateMemberStatus({ commit, state }, payload) {
            return new Promise((resolve, reject) => {
                commit('SET_LOADING', true);
                dataCards.updateMemberStatus(payload.groupId, payload.userId, payload.status).then(response => {
                    const resolvedStatus = (response && response.status) || payload.status;
                    const updatedMembers = state.groupMembers.map(m => {
                        if (m.id === payload.userId || m.user_id === payload.userId) {
                            return { ...m, status: resolvedStatus };
                        }
                        return m;
                    });
                    commit('SET_GROUP_MEMBERS', updatedMembers);
                    commit('SET_LOADING', false);
                    resolve(response);
                }).catch(error => {
                    commit('SET_LOADING', false);
                    reject(error);
                });
            });
        },
    }
};

export default dataCardsModule;
